module.exports = __webpack_public_path__ + "static/albedo-selected-dfdaca75d153a48e7b9f45528aa89ef0.png";